const imageQuoteUrl =
  'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2Fff6f93ffcb95458a97e5bb2cd152435a'
const thumbnailUrl =
  'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2Fe792fe4c19cd4141a2cc7b5ce6f16ca8'

export const defaultProps = {
  backgroundColor: 'rgba(238, 225, 198, 0.2)',
  mainQuoteColor: 'rgba(22, 24, 25, 1)',
  secondaryQuoteColor: 'rgba(105, 101, 79, 1)',
  alignment: 'center',
  reviews: [
    {
      mainQuote: '“Hot flashes are gone”',
      secondaryQuote: '~ Jessica C.',
      imageQuoteUrl,
      imageQuoteAlt: '5 stars rating',
      thumbnailUrl,
      thumbnailAlt: 'Jessica C.',
    },
    {
      mainQuote: '“Hot flashes are gone”',
      secondaryQuote: '~ Jessica C.',
      imageQuoteUrl,
      imageQuoteAlt: '5 stars rating',
    },
    {
      mainQuote: '“Hot flashes are gone”',
      secondaryQuote: '~ Jessica C.',
      thumbnailUrl,
      thumbnailAlt: 'Jessica C.',
    },
    {
      mainQuote: '“Hot flashes are gone”',
      secondaryQuote: '~ Jessica C.',
      imageQuoteUrl,
      imageQuoteAlt: '5 stars rating',
      thumbnailUrl,
      thumbnailAlt: 'Jessica C.',
    },
    {
      mainQuote: '“Hot flashes are gone”',
      secondaryQuote: '~ Jessica C.',
      imageQuoteUrl,
      imageQuoteAlt: '5 stars rating',
    },
    {
      mainQuote: '“Hot flashes are gone”',
      secondaryQuote: '~ Jessica C.',
      thumbnailUrl,
      thumbnailAlt: 'Jessica C.',
    },
  ],
}
